import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { classNames } from "Utils/utils";
import Header from "components/common/Header/Header";
import SideBarNew from "components/common/SideBar/SideBarNew";
import { LoginContext } from "helpers/LoginContext";
import { isPlanFeatureAllowed } from "helpers/planFeatures";
import { getUser } from "store/selector/auth.selector";
import { HiOutlineLockClosed } from "react-icons/hi";
import { CgFileDocument } from "react-icons/cg";
import { FiSettings } from "react-icons/fi";
import { useNavigate } from "react-router";
import { RiCalendar2Fill } from "react-icons/ri";
import { RiTeamLine } from "react-icons/ri";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { BsImageFill } from "react-icons/bs";
import { MdListAlt } from "react-icons/md";
import { HiOutlineSparkles, HiOutlineAcademicCap } from "react-icons/hi";
import { isAiFeaturesEnabled } from "config/aiFeatureFlags";


const PersonalSetting = () => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const navigate = useNavigate();
  const currentUser = useSelector(getUser);
  const regionsLocked = !isPlanFeatureAllowed(currentUser, "regions");

  const cards = [
    {
      name: "SP Settings",
      role: "Service Provider Settings",
      href: "settings/sp-setting",
      icon: FiSettings,
      bgColor: "#8C198F",
      userRole: [],
      for: "Sp Setting",
      //   permissionChild: PERMISSION_KEYS_CHILDREN.HRM.APPLICANT.SHOW,
    },

    {
      name: "Worker Compliance Settings",
      role: "Manage workers compliance settings",
      href: "settings/worker-compliance-setting",
      icon: CgFileDocument,
      bgColor: "#FF456E",
      userRole: [],
      for: "Worker Compliance Settings",
      //   permissionChild: PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW,
    },
    {
      name: "Participant Compliance Settings",
      role: "Manage participants compliance settings",
      href: "settings/participant-compliance-setting",
      icon: CgFileDocument,
      bgColor: "#b157bd",
      userRole: [],
      for: "Participant Compliance Settings",
    },
    {
      name: "Rostering Settings",
      role: "Manage Rostering settings",
      href: "settings/rostering-setting",
      icon: RiCalendar2Fill,
      bgColor: "#6C456E",
      userRole: [],
      for: "Rostering Settings",
    },
    {
      name: "Region Settings",
      role: regionsLocked
        ? "Upgrade to Elevated or Platinum to manage regions"
        : "Manage Region Settings",
      href: "settings/region-setting",
      icon: regionsLocked ? HiOutlineLockClosed : RiTeamLine,
      bgColor: "#ADC3FB",
      userRole: [],
      for: "Region Settings",
      planLocked: regionsLocked,
      //   permissionChild: PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW,
    },
    {
      name: "Incident Reporting Settings",
      role: "Manage Incident Reporting Settings",
      href: "settings/incident-reporting-setting",
      icon: BsExclamationTriangleFill  ,
      bgColor: "#FF5151",
      userRole: [],
      for: "Incident Reporting Settings",
      //   permissionChild: PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW,
    },
    {
      name: "Branding",
      role: "Manage Branding Settings",
      href: "settings/branding",
      icon: BsImageFill  ,
      bgColor: "#2c3e50",
      userRole: [],
      for: "Branding",
      //   permissionChild: PERMISSION_KEYS_CHILDREN.HRM.WORKER.SHOW,
    },
    {
      name: "Funding Settings",
      role: "Manage Funding Settings",
      href: "settings/funding-setting",
      icon: FiSettings,
      bgColor: "#FF8C00",
      userRole: [],
      for: "Funding Settings",
    },
    {
      name: "Service Agreement Settings",
      role: "Manage Service Agreement PDF template",
      href: "settings/service-agreement-setting",
      icon: CgFileDocument,
      bgColor: "#0F766E",
      userRole: [],
      for: "Service Agreement Settings",
    },
    {
      name: "Service Categories & Line Items",
      role: "Manage service categories and line items by funding type for rostering and invoicing",
      href: "settings/service-categories-line-items",
      icon: MdListAlt,
      bgColor: "#0d9488",
      userRole: [],
      for: "Service Categories & Line Items",
    },
    {
      name: "Integrations",
      role: "Connect third-party services",
      href: "settings/integrations",
      icon: HiOutlineAcademicCap,
      bgColor: "#1a56db",
      userRole: [],
      for: "Integrations",
    },
    {
      name: "AI Settings",
      role: "Control organisation-wide AI feature access",
      href: "settings/ai-settings",
      icon: HiOutlineSparkles,
      bgColor: "#4B6CB7",
      userRole: [],
      for: "AI Settings",
      requiresAiFeatures: true,
    },
    {
      name: "AI Credits & Usage",
      role: "View AI credit balance and usage history",
      href: "settings/ai-usage",
      icon: HiOutlineSparkles,
      bgColor: "#4B6CB7",
      userRole: [],
      for: "AI Credits & Usage",
      requiresAiFeatures: true,
    },
  ].filter((card) => isAiFeaturesEnabled || !card?.requiresAiFeatures);

  return (
    <>
      <div className='min-full'>
        <SideBarNew classes='bg-gradient' />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          } flex flex-col fullScreenHeight`}
        >
          <main className='flex-1'>
            <Header title='Business Settings' />
            <div className='min-full'>
              <div className='w-full sm:px-6 lg:px-8 space-y-6 py-8'>
                <div
                  className={`grid gap-3 p-6 bg-gray-50 md:rounded-lg lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1`}
                >
                  {cards.map((card, index) => (
                    <div
                      onClick={() => {
                        if (card.planLocked || !card.href) {
                          return;
                        }
                        navigate(`/${card.href}`);
                      }}
                      role='button'
                      tabIndex={0}
                      key={index}
                      className={classNames(
                        "cursor-pointer relative rounded-lg border bg-white p-1 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500 capitalize",
                        card.planLocked
                          ? "border-amber-300 bg-amber-50/40"
                          : "border-gray-300"
                      )}
                    >
                      <div
                        className={classNames(
                          "flex-shrink-0 flex items-center justify-center w-16 h-12 py-8 text-white text-sm font-medium rounded-md"
                        )}
                        style={{ backgroundColor: `${card.bgColor}` }}
                      >
                        <card.icon
                          className={classNames(
                            "flex-shrink-0 h-5 w-5 text-white"
                          )}
                          aria-hidden='true'
                        />
                      </div>
                      <div className='flex-1 min-w-0'>
                        <div className='focus:outline-none'>
                          <span
                            className='absolute inset-0'
                            aria-hidden='true'
                          />
                          <p className='text-sm font-medium text-gray-900 mt-3'>
                            {card.name}
                          </p>
                          <p className='text-sm text-gray-500 truncate mb-3'>
                            {card.role}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default PersonalSetting;
